import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import dayjs from 'dayjs';

import { Typography, Box, Button, TextField, LinearProgress, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { Menu as MainMenu } from '../../components/Menu';

import { getShipements } from '../../api/shipments';
import { useData } from '../../hooks/DataProvider';

import { DataGrid } from '@mui/x-data-grid';

import translations from '../../scripts/translations';

import { ModelShipment } from '../../models/ModelShipment';

import { ShipmentDirections, TransportMode, ShipmentStatus, Linked } from '../../scripts/configData';

import AssignIdx from '../../components/AssignIdx';


const Shipements = () => {

    const { updateDataShipement, language } = useData();
    const btns = translations.button[language];
    const page = translations.pages.shipments[language];

    const navigate = useNavigate();


    const [shipments, setShipements] = useState([]);
    const [selctedShipementInDataGreed, setSelctedShipementInDataGreed] = useState([]);

    const shipmentsDefaultFilter = { "linked": "notLinked", "shipmentStatus": ModelShipment.shipmentStatus.default }

    const getLocalFilter = () => {
        const localFilter = localStorage.getItem('shipmentsFilter');
        return localFilter ? JSON.parse(localFilter) : {};
    };

    const [shipmentsFilter, setShipementsFilter] = useState(shipmentsDefaultFilter);
    const [loading, setLoading] = useState(false);


    const setLocalFilter = (filter) => {
        localStorage.setItem('shipmentsFilter', JSON.stringify(filter));
    };



    const updateShipementsFilter = (newFilter) => {
        let currentFilter = {}
        if (newFilter.value === '') {
            currentFilter = { ...shipmentsFilter };
            delete currentFilter[newFilter.field];
            setShipementsFilter(currentFilter)
        }
        else {
            currentFilter = { ...shipmentsFilter, [newFilter.field]: newFilter.value }
        }
        setShipementsFilter(currentFilter)
        setLocalFilter(currentFilter);

    }

    const clearShipementsFilter = () => {
        setShipementsFilter(shipmentsDefaultFilter);
        setLocalFilter(shipmentsDefaultFilter);
        fetchShipements(shipmentsDefaultFilter);
    };



    const fetchShipements = async (filter=shipmentsDefaultFilter) => {
        try {
            setLoading(true);
            let startTime = new Date().getTime();
            const response = await getShipements(filter);
            setShipements(response);

            console.log('Shipements fetched successfully:', response);
            let endTime = new Date().getTime();
            console.log(`Fetch Shipements took ${endTime - startTime} ms`);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching shipments:', error);
        }
    };

    useEffect(() => {

        const rq = async () => {

            const filters = await getLocalFilter()
            if (Object.keys(filters).length > 0) {                
                setShipementsFilter(filters);
                fetchShipements(filters);
            } else {
                setShipementsFilter(shipmentsDefaultFilter);
                fetchShipements(shipmentsDefaultFilter);
            }
        }
        rq();

    }, []);


    const handleShipementUpdate = (item) => {
        updateDataShipement(item);
        navigate(`/shipments/${item._id}`);

    };

    const handelLinketShipements = (value) => {
        updateShipementsFilter({ field: 'linked', value })
        fetchShipements({ ...shipmentsFilter, linked: value });

    }


    const columnsShipements = [
        { field: 'linked', headerName: ModelShipment._linked[language], width: 90, renderCell: (params) => params.row.linked_arr?.[0]?.consolidationCode ? params.row.linked_arr[0].consolidationCode : '' },
        { field: 'shipmentOrderCode', headerName: ModelShipment.shipmentOrderCode[language], width: 90 },
        {
            field: 'creationDate',
            headerName: ModelShipment.creationDate[language],
            // width: 250,
            editable: false,
            valueGetter: (value, row) => dayjs(row.creationDate).format('DD/MM/YYYY') || ''
        },
        {
            field: 'orderingParty',
            headerName: ModelShipment.orderingParty[language],
            // width: 300,
            editable: false,
            valueGetter: (value, row) => `${row.orderingParty?.name || ''}`
        },
        {
            field: 'consignor',
            headerName: ModelShipment.consignor[language],
            // width: 300,
            editable: false,
            valueGetter: (value, row) => `${row.consignor?.name || ''}`
        },
        {
            field: 'consignee',
            headerName: ModelShipment.consignee[language],
            // width: 300,
            editable: false,
            valueGetter: (value, row) => `${row.consignee?.name || ''}`
        },
        {
            field: 'totalHandlingUnits',
            headerName: ModelShipment.totalHandlingUnits[language],
            // width: 300,
            editable: false,
        },
        {
            field: 'soWeight',
            headerName: ModelShipment.soWeight[language],
            // width: 300,
            editable: false,
        },
        {
            field: 'soChargeableWeight',
            headerName: ModelShipment.soChargeableWeight[language],
            // width: 300,
            editable: false,
        },
        {
            field: 'consolidationCustomerRef',
            headerName: page.consolidationCustomerRef,
            // width: 300,
            editable: false,
        },
        {
            field: 'consolidationInternalRef',
            headerName: page.consolidationInternalRef,
            // width: 300,
            editable: false,
        }
        

        

    ];


    const TextFieldProps = {
        variant: 'outlined',
        size: 'small',
        sx: { width: '100%' },
        InputLabelProps: {
            shrink: true,
        },
        autoComplete: "off"
    }

    return (
        <>
            <MainMenu currentPage={'shipments'} />

            <Box sx={{ mb: 0, py: 0, display: 'grid', gridTemplateColumns: '1fr 6fr 1fr', alignItems: 'center', gap: 2, justifyContent: 'space-between', }}>
                <Typography variant='overline' component='h1' sx={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
                    {page.title}
                </Typography>


                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Box sx={{ display: 'grid', gridTemplateColumns: '2fr 3fr', justifyContent: 'flex-end', gap: 1 }}>

                        <FormControl fullWidth>
                            <InputLabel
                                id={'_linked_selector'}
                                sx={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}
                                size="small"

                            >{ModelShipment._linked[language]}</InputLabel>
                            <Select
                                labelId={`_linked_selector`}
                                id={`linked`}
                                value={shipmentsFilter.linked || 'notLinked'} // Default to 'notLinked' if no filter is set
                                onChange={(e) => handelLinketShipements(e.target.value)}
                                variant='outlined'
                                size="small"
                                label={ModelShipment._linked[language]}
                                sx={{ width: 160 }}


                            // InputLabelProps={{
                            //     shrink: true,
                            // }}
                            >
                                {Linked.map((i) => (
                                    <MenuItem key={i.key} value={i.key}>{i[language]} </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <AssignIdx language={language} selctedShipementInDataGreed={selctedShipementInDataGreed} setSelctedShipementInDataGreed={setSelctedShipementInDataGreed} fetchShipements={fetchShipements} />
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Link to={`/shipments/new`} style={{ textDecoration: 'none', color: 'inherit' }}>
                        <Button variant='outlined' >{btns.add}</Button>
                    </Link>
                </Box>
            </Box >


            {/* search barre  */}
            <Box sx={{ mb: 2, py: 2, display: 'flex', gap: 2, justifyContent: 'space-between', alignItems: 'center' }}>

                <TextField
                    label={ModelShipment.shipmentOrderCode[language]}
                    value={shipmentsFilter.shipmentOrderCode || ''}
                    onChange={(e) => updateShipementsFilter({ field: 'shipmentOrderCode', value: e.target.value })}
                    {...TextFieldProps}
                />

                <TextField
                    label={ModelShipment.orderingParty[language]}
                    value={shipmentsFilter.orderingParty || ''}
                    onChange={(e) => updateShipementsFilter({ field: 'orderingParty', value: e.target.value })}
                    {...TextFieldProps}
                />
                <TextField
                    label={ModelShipment.consignor[language]}
                    value={shipmentsFilter.consignor || ''}
                    onChange={(e) => updateShipementsFilter({ field: 'consignor', value: e.target.value })}
                    {...TextFieldProps}
                />
                <TextField
                    label={ModelShipment.consignee[language]}
                    value={shipmentsFilter.consignee || ''}
                    onChange={(e) => updateShipementsFilter({ field: 'consignee', value: e.target.value })}
                    {...TextFieldProps}
                />


                <FormControl fullWidth>
                    <InputLabel
                        id={'transportModeSelector'}
                        sx={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}
                        size="small"
                        // shrink={true}

                    >{ModelShipment.transportMode[language]}</InputLabel>
                    <Select
                        labelId={`transportModeSelector`}
                        id={`transportModeSelector`}
                        value={shipmentsFilter.transportMode || ''}
                        onChange={(e) => updateShipementsFilter({ field: 'transportMode', value: e.target.value })}
                        variant='outlined'
                        size="small"
                        label={ModelShipment.transportMode[language]}
                    // InputLabelProps={{
                    //     shrink: true,
                    // }}
                    >
                        {TransportMode.map((i) => (
                            <MenuItem key={i.key} value={i.key}>{i[language]} </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl fullWidth>
                    <InputLabel
                        id={'shipmentStatusSelector'}
                        sx={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}
                        size="small"
                        shrink={true}
                    >{ModelShipment.shipmentStatus[language]}
                    </InputLabel>
                    <Select
                        labelId={`shipmentStatusSelector`}
                        id={`shipmentStatusSelector`}
                        value={shipmentsFilter.shipmentStatus || ModelShipment.shipmentStatus.default || ''}
                        onChange={(e) => updateShipementsFilter({ field: 'shipmentStatus', value: e.target.value })}
                        variant='outlined'
                        size="small"
                        label={ModelShipment.shipmentStatus[language]}
                    >
                        {ShipmentStatus.map((i) => (
                            <MenuItem key={i.key} value={i.key}>{i[language]} </MenuItem>
                        ))}
                    </Select>
                </FormControl>


                <Box sx={{ display: 'flex', gap: 1 }}>

                    <Button variant='outlined' onClick={clearShipementsFilter} >{btns.clear}</Button>
                    <Button variant='outlined' onClick={() => {
                        console.log(shipmentsFilter)
                        fetchShipements(shipmentsFilter)
                    }} >{btns.search}</Button>
                </Box>




            </Box>



            {loading && <LinearProgress sx={{ mb: 2 }} />}

            {
                !loading && <Box sx={{ height: 520, width: '100%' }}>
                    <Box sx={{ width: '100%' }}>
                        <DataGrid

                            rows={shipments}
                            getRowId={(row) => row._id}
                            columns={columnsShipements}

                            showToolbar={true}
                            slotProps={{
                                toolbar: {
                                    printOptions: { disableToolbarButton: true },
                                },
                            }}
                            initialState={{
                                pagination: {
                                    paginationModel: {
                                        pageSize: 25,
                                    },
                                },
                            }}
                            pageSizeOptions={[25]}
                            checkboxSelection={true}
                            disableRowSelectionOnClick
                            onRowClick={(params) => handleShipementUpdate(params.row)}

                            onRowSelectionModelChange={(ids) => {
                                const arr = [...ids.ids].map(id => {
                                    const row = shipments.find(row => row._id === id)
                                    return { _id: row._id, shipmentOrderCode: row.shipmentOrderCode };
                                })
                                setSelctedShipementInDataGreed(arr);
                                console.log(arr)
                            }}

                            sx={{
                                '& .MuiDataGrid-row:hover': {
                                    cursor: 'pointer',
                                },
                                '& .MuiDataGrid-cell:focus': {
                                    outline: 'none',
                                },
                                // height: '100%',
                            }}
                        />
                    </Box>
                </Box>
            }


        </>
    );
}

export default Shipements;